import { render } from "./FontButton.vue?vue&type=template&id=5de1f988&ts=true"
import script from "./FontButton.vue?vue&type=script&lang=ts"
export * from "./FontButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__